export default function (state = {
	isOpen: false,
}) {
	return {
		isOpen: state.isOpen,
		activeNodeId: null,

		init() {
			this.events()
			this.resize()
		},

		events() {
			window.addEventListener('primary-menu:toggle', () => {
				this.toggle()
			})

			window.addEventListener('keyup', (event) => {
				if (event.key === 'Escape' && this.isOpen) {
					this.toggle()
				}
			})
		},

		resize() {
			if (!this.$refs.wrapper) {
				return
			}

			new ResizeObserver(() => {
				if (
					!this.isOpen
					|| window.innerWidth < 1024
				) {
					return
				}

				this.toggle()
			}).observe(this.$refs.wrapper)
		},

		toggle() {
			this.isOpen = !this.isOpen

			if (!this.isOpen) {
				document.body.classList.remove('has-overlay')
				this.activeNodeId = null
			} else {
				document.body.classList.add('has-overlay')
			}
		},

		setActiveNodeId($event, id) {
			if (window.innerWidth >= 1024) {
				return
			}

			$event.preventDefault()
			this.activeNodeId = id
		},
	}
}
